import {
  divider_default
} from "../../chunk-BCJZ2XM2.js";
export {
  divider_default as default
};
